<template>
  <div>
    <b-button
        pill
        variant="dark"
        style="margin-left: 15px;"
        class="float-right"
        @click="handleStartAutomation"
    >
      Automate
    </b-button>
    <b-modal
        :id="modalId"
        hide-header
        hide-footer
        centered
        content-class="shadow"
    >
      <p class="my-2">
        Automation is Beginning
      </p>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "HeartBeat_CarePlan_Block_Automate",
  components: {},
  created(){},
  beforeMount() {},
  mounted() {},
  props: {
    heartbeat: {
      type: Object,
      default: () => {
        return {}
      }
    },
    info: {
      type: Array,
      default: () => {
        return []
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {}
      }
    },
    doc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    apps: {
      type: Array,
      default: () => {
        return [];
      }
    },
    sectionId: {
      type: String,
      default: 'none'
    },
    planId: {
      type: String,
      default: 'none'
    },
  },
  computed: {
    ...mapGetters({}),
    providerId() {
      return this.profile && this.profile.userId ? this.profile.userId : null;
    },
    docId() {
      return this.doc && this.doc.id ? this.doc.id : null;
    },
    modalId() {
      return `automate-modal-id-${this.doc && this.doc.id ? this.doc.id : 0}-${this.sectionId}`;
    }
  },
  methods: {
    handleStartAutomation() {
      this.$bvModal.show(this.modalId);
      const profileBy = this.profileBy();

      const automation = {
        isSigned: true,
        _created_by: profileBy,
        _created_at: new Date()
      };

      if (this.comment) automation.comment = this.comment;

      this.$store
          .dispatch("provider/addSectionTrackForProviderIdPlanIdDocId", {
            sectionId:  this.sectionId,
            trackProperty: 'automations',
            payload: automation,
            providerId: this.providerId,
            planId: this.planId,
            docId: this.docId,
            updatedBy:{}
          })
          .then(({ }) => {

          })
          .catch(err => {});
    },
    profileBy() {
      return {
        uid: this.profile && this.profile.userId ? this.profile.userId : null,
        name: this.profile
            ? `${this.profile.firstname} ${this.profile.lastname}`
            : null,
        imgURL: this.profile ? this.profile.imgURL : null,
        comment: null
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>